export const AD_CREATIVE_TYPE = 'ad_creative_type'
export const CREATIVE_FILE_UPLOAD = 'creative_file_upload'
export const CAMPAIGN_MANAGER_THIRD_PARTY_CREATIVE_TAGS = 'campaign_manager_third_party_creative_tags'
